/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto';
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantTaskService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantTask(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskOutputDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-task',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantTaskSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-task-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
